import { Box } from 'grommet';
import React from 'react';
import styled from 'styled-components';
import { Button } from './Button';
import { ContentItem } from './ContentItem';
import { PageSection, SectionBody, SectionHeader } from './PageSection';

const StyledBody = styled(SectionBody)`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
`;

const StyledBox = styled(Box)`
  grid-column: 1 / span 4;
  padding-top: 2.5rem;
`;

const StyledContentItem = styled(ContentItem)`
  padding-right: 30px;
  text-align: center;
 
`;

export const FourUpSection = ({ title, items, ctaLabel, ctaUrl }) => {
  return (
    <PageSection backgroundColor="black">
      <SectionHeader title={title} theme="dark" />
      <StyledBody>
        {items.map((item, i) => (
          <StyledContentItem
            key={`fourUpContentItem${i}`}
            {...item}
            textColor="white"
          />
        ))}
        {/* <StyledBox align="center">
          <Button onDark label={ctaLabel} href={ctaUrl} />
        </StyledBox> */}
      </StyledBody>
    </PageSection>
  );
};
